export enum ExperienceEndpoints {
    Experiences = '/experiences',
}